import { render, staticRenderFns } from "./EditorMain.vue?vue&type=template&id=0a958538&"
import script from "./EditorMain.vue?vue&type=script&lang=ts&"
export * from "./EditorMain.vue?vue&type=script&lang=ts&"
import style0 from "./EditorMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports